import React from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router";
import fireImg from "../../../assets/media/fire.png";
import { idealTextColor } from "../../../functions";
const HotContent = ({
  type,
  title,
  description,
  image_url,
  media_url,
  id,
  brand_name,
  hex,
}) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="hotContent_row">
      <div className="_content">
        <div className="col-div">
          <p className="_title">{title}</p>
          <p className="_description">{description}</p>
        </div>
        {type === "hotTopic" && (
          <div
            className="_img"
            style={{ backgroundImage: `url(${media_url})` }}
          >
            <img src={fireImg} alt="fire" />
          </div>
        )}
        {type === "hotVideo" && (
          <div className="_img">
            <ReactPlayer
              url={media_url}
              width="100%"
              height="100%"
              controls={true}
            />
          </div>
        )}
      </div>

      <div className="col-div" style={{ width: 150, marginLeft: 10 }}>
        <Link
          to={{
            pathname: type === "hotTopic" ? `/hot-topic/${id}` : "/hot-topic",
            state: {
              brand_name: brand_name,
              ...location.state,
            },
          }}
          style={{ width: "100%" }}
        >
          <button
            className="btn btn-white btn-brand-hex"
            style={{
              fontSize: "14px",
              width: "100%",
              "--hover-color": hex || "white",
              "--hover-text-color": idealTextColor(hex),
            }}
          >
            {type === "hotTopic" ? "Edit hot topic" : "Edit hot video"}
          </button>
        </Link>
        <button
          className="btn btn-white btn-brand-hex"
          style={{
            fontSize: "14px",
            width: "100%",
            marginTop: 10,
            "--hover-color": hex || "white",
            "--hover-text-color": idealTextColor(hex),
          }}
          onClick={() => {
            history.push("/hot-topic", { ...location.state, fromPage: type });
          }}
        >
          {type === "hotTopic" ? "Manage hot topics" : "Manage hot videos"}
        </button>
      </div>
    </div>
  );
};

export default HotContent;



// WEBPACK FOOTER //
// ./src/screens/Planner/components/HotContent.js